export const MesureListStyle = {
  width: "100%",
};
